import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getDocuments } from '~/src/api/content/documents';
import Ktv from '~/src/components/Ktv';
import Layout from '~/src/features/_layout';
import * as base from '~/src/helpers/basePageFunc';
import { selectCompanyName } from '~/src/store/selectors/city';

const KTV_DOCUMENT_ID = '8';

class KtvPage extends Component {
    static propTypes = {
        city: PropTypes.object.isRequired,
        companyName: PropTypes.string,
    };

    static async getInitialProps(options) {
        await base.initialProps(options);
        const { store } = options;
        const state = store.getState();
        const documentFiles = await getDocuments(state.city.provider.providerId, KTV_DOCUMENT_ID);
        const companyName = selectCompanyName(state);

        return { file: documentFiles[0], companyName };
    }

    render() {
        const { city: { cityIn, phone }, file, companyName } = this.props;

        return (
            <Layout
                title={`Подключить кабельное телевидение от ${companyName} в ${cityIn} | Стоимость услуги кабельного ТВ в квартире и доме`}
                description={`Официальный сайт ${companyName} в ${cityIn} | Переходите с домашнего кабельного ТВ на современное цифровое телевидение. Оставьте заявку на сайте или по ☎ ${phone}.`}
                withMenu={true}
                withFooter={true}
                withChat={true}
            >
                <Ktv file={file}/>
            </Layout>
        );
    }
}

const mapStateToProps = state => ({
    city: state.city.currentCity,
});

export default connect(mapStateToProps)(KtvPage);
